import { createFileRoute } from '@tanstack/react-router';

import { Button } from '@/components/ui/Button';
import { YStack } from '@/components/ui/layout/layout';
import { CredentialRequestForm } from '@/features/browser-stream/CredentialRequestForm';
import { useSignInSessionQuery } from '@/features/browser-stream/sign-in-session.query';

export const BrowserSignIn = () => {
  const { signInSessionId } = Route.useParams();
  const { data, isPending, isError, isFetching, refetch } =
    useSignInSessionQuery(signInSessionId);
  return (
    <YStack className="h-full min-h-0 w-full overflow-y-auto text-foreground">
      <YStack className="mx-auto w-full max-w-lg gap-6 px-4 py-6 sm:px-6 sm:py-12">
        <h1 className="sr-only">Browser request</h1>
        {isPending ? (
          <YStack
            center
            className="min-h-48 rounded-xl border border-border bg-surface p-6 text-center"
          >
            <p role="status">Loading request…</p>
          </YStack>
        ) : null}
        {data === null ? (
          <YStack
            center
            className="min-h-48 gap-4 rounded-xl border border-border bg-surface p-6 text-center"
          >
            <p role="status">This sign-in request is no longer available.</p>
            <p className="text-muted-foreground">
              Return to your conversation and ask for a new sign-in request.
            </p>
          </YStack>
        ) : null}
        {isError && data === undefined ? (
          <YStack
            center
            className="min-h-48 gap-4 rounded-xl border border-border bg-surface p-6 text-center"
          >
            <p role="alert">Couldn’t load this request</p>
            <Button
              variant="secondary"
              className="min-h-11"
              disabled={isFetching}
              onClick={() => void refetch()}
            >
              Try again
            </Button>
          </YStack>
        ) : null}
        {data ? (
          <CredentialRequestForm
            key={`${data.sign_in_session_id}:${data.request?.input_request_id}`}
            request={data}
          />
        ) : null}
      </YStack>
    </YStack>
  );
};

export const Route = createFileRoute(
  '/_browser-request/browser-sign-in/$signInSessionId'
)({
  component: BrowserSignIn,
});
